import { Type } from "@sinclair/typebox";
import { OptionSide, SpiceLevel } from "../enums";
import { OPTION_TEXT_MAX, REACTION_EMOJI } from "../limits";
export const AssignmentSchema = Type.Object({
    index: Type.Integer(),
    author_id: Type.String(),
    target_id: Type.String(),
});
export const WsRequestSuggestionPayloadSchema = Type.Object({
    request_id: Type.String({ minLength: 1, maxLength: 64 }),
    spice: Type.Enum(SpiceLevel),
});
export const WsSuggestionPayloadSchema = Type.Object({
    request_id: Type.String({ minLength: 1, maxLength: 64 }),
    suggestion_id: Type.String(),
    text: Type.String(),
    spice: Type.Enum(SpiceLevel),
});
export const WsSubmitDecisionPayloadSchema = Type.Object({
    assignment_index: Type.Integer(),
    option_a: Type.String({ minLength: 1, maxLength: OPTION_TEXT_MAX }),
    option_b: Type.String({ minLength: 1, maxLength: OPTION_TEXT_MAX }),
    suggestion_a_id: Type.Union([Type.String(), Type.Null()]),
    suggestion_b_id: Type.Union([Type.String(), Type.Null()]),
});
export const GameSetupStateSchema = Type.Object({
    assignments: Type.Array(AssignmentSchema),
    decisions_per_player: Type.Integer(),
    deadline_at: Type.String(),
    submitted_players: Type.Array(Type.String()),
});
export const WsChoosePayloadSchema = Type.Object({
    side: Type.Enum(OptionSide),
});
export const WsGuessPayloadSchema = Type.Object({
    side: Type.Enum(OptionSide),
});
export const TurnStartedPayloadSchema = Type.Object({
    target_id: Type.String(),
    option_a: Type.String(),
    option_b: Type.String(),
    deadline_at: Type.String(),
    turn_number: Type.Integer(),
    total_turns: Type.Integer(),
    responded_players: Type.Array(Type.String()),
});
export const GuessResultSchema = Type.Object({
    user_id: Type.String(),
    /**
     * Null when the player never answered. Every eligible guesser appears here,
     * answered or not — plan.md §1.7 counts a missing guess as incorrect, so
     * omitting them would both hide them and misstate the denominator.
     */
    guess: Type.Union([Type.Enum(OptionSide), Type.Null()]),
    correct: Type.Boolean(),
});
export const TurnRevealedPayloadSchema = Type.Object({
    valid: Type.Boolean(),
    target_id: Type.String(),
    author_id: Type.String(),
    option_a: Type.String(),
    option_b: Type.String(),
    target_choice: Type.Union([Type.Enum(OptionSide), Type.Null()]),
    guesses: Type.Array(GuessResultSchema),
    correct_count: Type.Integer(),
    deadline_at: Type.String(),
});
export const RankingEntrySchema = Type.Object({
    user_id: Type.String(),
    score: Type.Integer(),
    position: Type.Integer(),
});
export const GameOverPayloadSchema = Type.Object({
    ranking: Type.Array(RankingEntrySchema),
    /** When the results screen returns to the lobby on its own. Absolute. */
    results_deadline_at: Type.Union([Type.String(), Type.Null()]),
});
export const WsReactPayloadSchema = Type.Object({
    emoji: Type.Union(REACTION_EMOJI.map((e) => Type.Literal(e))),
});
export const ReactionPayloadSchema = Type.Object({
    emoji: Type.Union(REACTION_EMOJI.map((e) => Type.Literal(e))),
});
